import React from 'react';
import { useTranslation } from 'react-i18next';
import { FacebookIcon, TwitterIcon, LinkedInIcon, YoutubeIcon } from './socialIcons';
import styles from './Footer.module.scss';

const socialLinks = [
  { label: 'Facebook', href: 'https://facebook.com/airooki', Icon: FacebookIcon },
  { label: 'Twitter', href: 'https://twitter.com/airooki', Icon: TwitterIcon },
  { label: 'LinkedIn', href: 'https://linkedin.com/company/airooki', Icon: LinkedInIcon },
  { label: 'YouTube', href: 'https://youtube.com/@airooki', Icon: YoutubeIcon },
];

export const Footer: React.FC = () => {
  const { t } = useTranslation('footer');

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.top}>
          <div className={styles.brandCol}>
            <img
              src="/assets/logo-signature-color.svg"
              alt="Airooki"
              className={styles.signature}
            />
            <address className={styles.address}>
              {t('addressLine1')}
              <br />
              {t('addressLine2')}
              <br />
              {t('addressLine3')}
            </address>
          </div>

          <nav className={styles.navCol}>
            <p className={styles.colTitle}>{t('company')}</p>
            <a href="mailto:hello@airooki.com" className={styles.colLink}>
              {t('contactUs')}
            </a>
          </nav>

          <nav className={styles.navCol}>
            <p className={styles.colTitle}>{t('legal')}</p>
            <a href="/terms" className={styles.colLink}>
              {t('terms')}
            </a>
            <a href="/sla" className={styles.colLink}>
              {t('sla')}
            </a>
          </nav>

          <nav className={styles.navCol}>
            <p className={styles.colTitle}>{t('connect')}</p>
            {socialLinks.map(({ label, href, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                className={styles.socialLink}
              >
                <Icon />
                {label}
              </a>
            ))}
          </nav>
        </div>

        <div className={styles.bottom}>
          <p className={styles.copy}>{t('rights', { year: new Date().getFullYear() })}</p>
        </div>
      </div>
    </footer>
  );
};
